import { Command, HttpMethod } from "~/extensions/api";
export class ValidateCode extends Command {
    constructor(command) {
        super(HttpMethod.Post, "keiyaku/mail/validate");
        this.authCode = command;
    }
    authCode = "";
}
